<template>
  <div class="sf-el company-name-input">
    <div class="sf-company-name">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>
      <input type="text" v-model="value" :placeholder="placeholder" />
    </div>
  </div>
</template>

<script>
  import { watch, ref } from 'vue';
  export default {
    name: 'CompanyNameElement',
    props: {
      label: String,
      description: String,
      caption: String,
      name: String,
      modelValue: String,
      required: Boolean,
      placeholder: String,
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const value = ref(props.modelValue);

      // Emit changes when user types
      watch(value, (newValue) => {
        emit('update:modelValue', newValue);
      });

      // Update local value if parent changes modelValue
      watch(
        () => props.modelValue,
        (newVal) => {
          if (newVal !== value.value) {
            value.value = newVal;
          }
        }
      );

      return {
        value,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-company-name {
  }
</style>
